import { captureAuthOwner } from "./auth-owner";
import { AuthenticationStore } from "./authenticationStore";
import { accessTokenExpiringLeewaySeconds, getUserManager, waitForAuthReady } from "./user-manager";

/** Due-only best effort. Without Web Locks, cross-tab rotating-token coordination is best effort. */
export async function refreshAccessToken(leewaySeconds: number = accessTokenExpiringLeewaySeconds): Promise<void> {
  try {
    await waitForAuthReady();
    if (!isStoredAccessTokenDueForRenewal(leewaySeconds)) return;
    const owner = captureAuthOwner();
    if (!owner) return;
    await getUserManager().renew({ leewaySeconds, owner });
  } catch {
    // Transient failures retain the still-owned session; the next explicit attempt can retry.
  }
}

/** Renews rejected canonical credentials, never replays an operation, and refuses an unlocked exchange. */
export async function forceRefreshAccessToken(rejectedToken: string): Promise<void> {
  const owner = captureAuthOwner();
  if (!owner) return;
  try {
    await getUserManager().renew({ rejectedToken, owner });
  } catch {
    // Preserve the original rejected operation's result, not an auth-recovery error.
  }
}

export function isStoredAccessTokenExpired(): boolean {
  return isStoredAccessTokenDueForRenewal(0);
}

export function isStoredAccessTokenDueForRenewal(leewaySeconds: number): boolean {
  const expiresAt = AuthenticationStore().getAccessTokenExpires();
  return !!expiresAt && Date.now() > (expiresAt - leewaySeconds) * 1000;
}
